module.exports = __webpack_public_path__ + "static/media/360.602be170.svg";